import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

interface Record {
    createdAt?: string;
    endedAt?: string;
    isActive?: boolean;
}

interface GetDurationOptions {
    format?: 'HH:mm:ss' | 'minutes-seconds';
}

export function getDuration(record: Record, options: GetDurationOptions = { format: 'HH:mm:ss' }): string {
    if (!record.createdAt) {
        return "";
    }

    const start = dayjs(record.createdAt);

    const end = record.isActive ? dayjs() : (record.endedAt ? dayjs(record.endedAt) : dayjs());

    const difference = end.diff(start);
    const differenceDuration = dayjs.duration(difference);

    if (options.format === 'minutes-seconds') {
        const minutes = Math.floor(differenceDuration.asMinutes());
        const seconds = differenceDuration.seconds();

        if (minutes === 0) {
            return `${seconds}s`;
        } else if (minutes < 60) {
            return `${minutes}m ${seconds}s`;
        } else {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            return `${hours}h ${remainingMinutes}m ${seconds}s`;
        }
    }

    return differenceDuration.format('HH:mm:ss');
}
